export default __webpack_public_path__ + "assets/images/itemlist-bg2-f99aed2e.jpg";